import './FileTypeCell.scss';
import React, {useContext} from 'react';
import {I18nReactContext} from "../../../../../contexts/I18nContext";
import ImageIcon from '@mui/icons-material/Image';
import VideocamIcon from '@mui/icons-material/Videocam';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const FileTypeCell = ({type}) => {
    const {i18n} = useContext(I18nReactContext);

    const getIcon = () => {
        const typeUpper = type ? type.toUpperCase() : '';
        switch(typeUpper) {
            case 'IMAGE':
                return <ImageIcon className="icon image" />;
            case 'VIDEO':
                return <VideocamIcon className="icon video" />;
            default:
                return <InsertDriveFileIcon className="icon file" />;
        }
    };

    const getTypeLabel = () => {
        const typeUpper = type ? type.toUpperCase() : '';
        switch(typeUpper) {
            case 'IMAGE':
                return i18n.translate('superAdmin.assets.fileTypes.image');
            case 'VIDEO':
                return i18n.translate('superAdmin.assets.fileTypes.video');
            default:
                return i18n.translate('superAdmin.assets.fileTypes.file');
        }
    };

    return (
        <div className="FileTypeCell">
            {getIcon()}
            <span className="typeLabel">{getTypeLabel()}</span>
        </div>
    );
};
